import { Pipe, PipeTransform } from '@angular/core';
import { format } from '../schir-utils';

@Pipe({
	name: 'formatDate',
	standalone: false,
})
export class FormatDatePipe implements PipeTransform {
	transform(date: Date | string) {
		return format(date);
	}
}
